export default __webpack_public_path__ + "127645d5d825ab442986897906d5cd37.svg";